module.exports = __webpack_public_path__ + "img/template6.ffe675ec.png";